<template>
  <div class="container">
    <h1 class="topic-title">기사를 선택하세요</h1>
    <p class="newslist-info">핵심 기사를 완성하면 포인트가 2배!</p>
    <div class="news-nine">
      <newsItem
        class="for-chi"
        v-for="(item, index) in news"
        :key="item.gridid"
        :item="item"
        :news="news"
        :index="index"
      ></newsItem>
      <div
        class="chi null"
        v-for="(item, index) in 9 - news.length"
        :key="9 - index"
      ></div>
    </div>
    <router-link to="/game/">
      <div class="back-button"></div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import newsItem from '@/components/newsItem.vue'
/* eslint-disable */

export default {
  data() {
    return {};
  },
  components: {
    newsItem,
  },
  computed: {
    ...mapGetters({
      news: "newsGrid",
      points: "current_section_article_point",
      iscomplete: "newsStates",
      current_section_id: "current_section_id",
    }),
  },
};
</script>

<style>
.link.악수 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
}

/*
.link.여행 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
}
.link.우리말 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
}
.link.구보 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
}
.link.예매 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
}
.link.파발마 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
}
.link.총알 {
  background-image: url("../assets/img/pairlink.png");
  background-size: contain;
} */
</style>



// WEBPACK FOOTER //
// src/components/newsList_.vue